import { IonicPlatformService } from './platform.service';

export default angular
  .module('sfMobile.services.platform', ['ionic'])
  .service('platformService', IonicPlatformService).name;
